import './WalletsTab.scss';
import { useEffect, useMemo } from 'react';
import 'react-loading-skeleton/dist/skeleton.css';

import HouseMoneyImage from '../../../../assets/icons/HouseMoneyWC.svg';
import HouseMoneyImg from '../../../../assets/icons/HouseMoneyImg.svg';
import TargetSavings from '../../../../assets/icons/TargetSavings.svg';
import TargetSavingsAct from '../../../../assets/icons/TargetSavingsAct.svg';
import Safelock from '../../../../assets/icons/Safelock.svg';
import SafelockActive from '../../../../assets/icons/SafelockActive.svg';
import MoneyNairaFlex from '../../../../assets/icons/MoneyNairaFlex.svg';
import MoneyUSDFlex from '../../../../assets/icons/MoneyUSDFlex.svg';
import PiggyBankWT from '../../../../assets/icons/PiggybankWT.svg';
import PiggyBankWTAC from '../../../../assets/icons/PiggybankWTAC.svg';
import flexDollarA from '../../../../assets/icons/flexDollarA.svg';

import HouseMoneyTab from './Wallets/Housemoney/index';
import TargetTab from './Wallets/Target';
import PiggyBankTab from './Wallets/Piggybank';
import SafelockTab from './Wallets/Safelock';
import FlexNairaTab from './Wallets/FlexNaira';
import FlexDollarTab from './Wallets/FlexDollar';
import { useNavigate } from 'react-router-dom';
import useRolePermissions from '../../../../hooks/useRolePermissions';

const WalletsTab = ({ activeTabWallet, setActiveTabWallet, setActiveTab }: any) => {
  const { restrictTabViewByRole } = useRolePermissions({});
  const navigate = useNavigate();
  const routes = useMemo(() => {
    return [
      {
        name: 'House Money',
        activeIcon: HouseMoneyImage,
        key: 'housemoney',
        icon: activeTabWallet === 'housemoney' ? HouseMoneyImage : HouseMoneyImg,
        path: '?wallet=housemoney',
        bgColor: activeTabWallet === 'housemoney' ? '#FFF2EA' : '',
        textColor: activeTabWallet === 'housemoney' ? '#F37932' : '',
        isActive: true,
        category: 'account',
      },
      {
        name: 'Target',
        icon: activeTabWallet === 'target' ? TargetSavingsAct : TargetSavings,
        key: 'target',
        path: '?wallet=target&status=active',
        isActive: true,
        category: 'target',
        bgColor: activeTabWallet === 'target' ? '#E4F7F3' : '',
        textColor: activeTabWallet === 'target' ? '#00896B' : '',
      },
      {
        name: 'Safelock',
        icon: activeTabWallet === 'safelock' ? SafelockActive : Safelock,
        key: 'safelock',
        path: '?wallet=safelock&status=active',
        isActive: true,
        category: 'account',
        bgColor: activeTabWallet === 'safelock' ? '#E9F4FE' : '',
        textColor: activeTabWallet === 'safelock' ? '#2295F2' : '',
      },
      {
        name: 'Piggybank',
        icon: activeTabWallet === 'piggybank' ? PiggyBankWTAC : PiggyBankWT,
        key: 'piggybank',
        path: '?wallet=piggybank',
        isActive: true,
        category: 'account',
        bgColor: activeTabWallet === 'piggybank' ? '#edf1fc' : '',
        textColor: activeTabWallet === 'piggybank' ? '#1734CA' : '',
      },

      {
        name: 'Flex Naira',
        icon: activeTabWallet === 'flexnaira' ? MoneyNairaFlex : MoneyUSDFlex,
        key: 'flexnaira',
        path: '?wallet=flexnaira',
        category: 'account',
        bgColor: activeTabWallet === 'flexnaira' ? '#FFF4F8' : '',
        isActive: true,
        textColor: activeTabWallet === 'flexnaira' ? '#EA417D' : '',
      },
      {
        name: 'Flex Dollar',
        icon: activeTabWallet === 'flexdollar' ? flexDollarA : MoneyUSDFlex,
        key: 'flexdollar',
        path: '?wallet=flexdollar',
        category: 'account',
        bgColor: activeTabWallet === 'flexdollar' ? '#CFD1D4' : '',
        isActive: true,
        textColor: activeTabWallet === 'flexdollar' ? '' : '',
      },
      // {
      //   name: 'Salary Manager ',
      //   icon: activeTabWallet === 'salarymanager' ? SafelockActive : Safelock,
      //   key: 'salarymanager',
      //   path: '?wallet=salarymanager',
      //   category: 'account',
      //   bgColor: activeTabWallet === 'salarymanager' ? '#E9F4FE' : '',
      //   isActive: false,
      //   textColor: activeTabWallet === 'salarymanager' ? '#2295F2' : '',
      // },
    ];
  }, [activeTabWallet]);

  // const id = params.id as string;
  // const location = useLocation();
  // const pathname = location.pathname;

  const activeTab = useMemo(() => {
    return routes.find((route) => route.key === activeTabWallet);
  }, [activeTabWallet, routes]);

  // update the url bar
  useEffect(() => {
    if (!activeTab) return;
    navigate(activeTab.path, { replace: true });
  }, [activeTabWallet, activeTab]);

  useEffect(() => {
    const actionType = activeTabWallet;

    if (activeTabWallet === 'housemoney') {
      restrictTabViewByRole(actionType, 'view', () => setActiveTab('profile'));
    }

    actionType.length && restrictTabViewByRole(actionType, 'view', () => setActiveTabWallet('housemoney'));
  }, [activeTabWallet]);

  return (
    <>
      <div className="customer-page-tab-nav flex--2 pointer">
        {routes.map(({ key, name, icon, bgColor, textColor, isActive }) => {
          return (
            <div
              key={key}
              className={`link flex--2 ${!isActive && 'isDisabled'} ${activeTabWallet === key ? 'active ' : ''}`}
              style={{ backgroundColor: bgColor, color: textColor }}
              onClick={() => {
                if (!isActive) return;
                setActiveTabWallet(key);
              }}
            >
              {
                <span className="icon">
                  <img className="image" src={icon} />
                </span>
              }
              <span className="label">{name}</span>
            </div>
          );
        })}
      </div>
      <div className="wallets-tab">
        {activeTabWallet === 'housemoney' && <HouseMoneyTab />}
        {activeTabWallet === 'target' && <TargetTab />}
        {activeTabWallet === 'piggybank' && <PiggyBankTab />}
        {activeTabWallet === 'safelock' && <SafelockTab />}

        {activeTabWallet === 'flexnaira' && <FlexNairaTab />}
        {activeTabWallet === 'flexdollar' && <FlexDollarTab />}
      </div>
    </>
  );
};

export default WalletsTab;
